import React, { Component } from "react";
import { message, Modal, Spin, Icon } from "antd";
import { ajax, unparam, agoraClient, initVideo, countNumDown, countTimeDown, createTimeStr } from "utils/common";
// import TrtcRoom from "utils/trtcRoom";
import VideoHeader from "components/videoHeader";
import VideoFooter from "components/videoFooter";
import VideoModel from "components/videoModel";
import VideoPlayer from "./videoPlayer";
import VideoPusher from "./videoPusher";
import videoHome from "images/video-home.png";
import videoPlayAgain from "images/video-playAgain.png";
import videoReplay from "images/video-replay.png";
import videoAdjust from "images/video-adjust.png";
import tryFinish from "images/stop-try.png";
import startRecord from "images/start-record.png";
import "./index.less";
//视频面试状态
import VideoStatus from "components/videoStatus";
// 国际化
import i18nZh_cn from "utils/zh_cn";
import i18nEn_us from "utils/en_us";

// message全局配置
message.config({
    top: 300,
    duration: 3,
    maxCount: 3,
});

class App extends Component{
    // 获取视频实例
    videoPlayer = React.createRef();

    state={
        mode: "pusher",     //mode取值： pusher => 录制, player => 回放 
        time: "00:00:00",
        count: "--",
        isStart: false,
        questionIndex: 0,
        questionTotal: 0,
        paperId: "",
        channelName: "",
        question: {},
        papers: {},
        isTry: false,
        showModal: false,
        showConfirmModal: false,
        showReplayModal: false,
        btnText: "",
        repeatNum: 1,
        currentRepeatNum: 0,
        recordSecond: 0,
        videoUrl: "",
        duration: 12,
        showProgress: false,
        currentReplayNum: 2,
        showLoading: false,
        showTryFinish: false,
        recordStream: null,
        showPosture: false,
        showStatus: false,
        videoStatus: 0,
        notAddAccess: true,
        limitTime: undefined,
        isReRecord: false,  // 是否是重录状态
        fileNamePrefix: "", // 回放参数，传开始录制接口/v3/record/startRecord 返回的内容
        isRecordReady: false, // 录制组件是否准备就绪
    }

    componentDidMount() {
        const _this = this;
        //获取页面参数
        const queryString = unparam(location.search);
        var questionIndex = Number(queryString.questionIndex);
        const currentRepeatNum = typeof queryString.currentRepeatNum === "undefined"?
                                queryString.currentRepeatNum:
                                Number(queryString.currentRepeatNum);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        //是否显示调整界面
        this.setState({
            showPosture: queryString.showPosture ? true : false,
            i18n
        })
        //设置页面标题
        if(questionIndex < 0){
            document.title = i18n.pageTitle.tryRecord;
        }else{
            document.title = i18n.pageTitle.record;
        }
        // //SSE接受服务端推送事件
        // if(window.EventSource){
        //     this.eventSource = new EventSource("/oivi/record/blackDetection");
        //     this.eventSource.addEventListener('open', function (event) {
        //         // console.log("EventSource open: ", event);
        //     }, false);
        //     this.eventSource.addEventListener('message', function (event) {
        //         console.log("EventSource message: ", event);
        //         message.destroy()
        //         message.success(i18n.record.poorVideoQuality, 3);
        //     }, false);
        //     this.eventSource.addEventListener('error', function (event) {
        //         // console.log("EventSource error: ", event);
        //         // _this.eventSource.close();
        //     }, false);
        // }
        // // websocket
        // if(window.WebSocket){
        //  var ws = new WebSocket("wss://vtest.wintalent.cn/oivi/record/blackDetection");
        //  ws.onopen = function(evt) {
        //      console.log("Connection open ...");
        //      ws.send("Hello WebSockets!");
        //  };
        //  ws.onmessage = function(evt) {
        //      console.log( "Received Message: " + evt.data);
        //      ws.close();
        //  };
        //  ws.onclose = function(evt) {
        //      console.log("Connection closed.");
        //  };
        // }
        import("utils/trtcRoom").then(inst => {
            const TrtcRoom = inst.default;
            // 初始化TrtcRoom对象
            this.trtcRoomInst = new TrtcRoom(queryString.accountId, i18n)
            this.trtcRoomInst.createLocalStream({ elementId: "live-pusher" }, () => {
                //获取试卷
                ajax({
                    url: "/paper/getPaperById",
                    data: {
                        accountId: queryString.accountId
                    }
                }).then(res => {
                    //试卷列表
                    const papers = res.data;
                    //处理最后一题，最后
                    if(papers.interviewQuesVOs.length === questionIndex){
                        questionIndex--;
                    }
                    //保存试卷和accountId
                    this.setState({
                        papers: papers,
                        accountId: queryString.accountId,
                        isRecordReady: true
                    }, () => {
                        this.getPaper(questionIndex, currentRepeatNum, () => {
                            if(!queryString.showPosture){
                                _this.initRecord();
                            }
                            //离开频道
                            // agoraClient.leave(() => {
                            //     console.log("Leave channel successfully");
                            // }, err => {
                            //     console.log("Leave channel failed");
                            // });
                            // 加入频道开始推流
                            // ajax({
                            //     url: "/record/fetchChannelKey",
                            //     data: {
                            //         channelName: queryString.accountId
                            //     }
                            // }).then(res => {
                            //     initVideo({
                            //         channelKey: res.data,
                            //         channelName: queryString.accountId,
                            //         success(evt) {
                            //             //保存视频流对象
                            //             _this.setState({
                            //                 recordStream: evt.stream
                            //             })
                            //             if(!queryString.showPosture){
                            //                 _this.initRecord();
                            //             }
                            //         },
                            //         fail(err){
                            //             if(err === "NO_CAMERA_PERMISSION" ||
                            //                 err === "NO_MIC_PERMISSION" ||
                            //                 err.msg === "NotAllowedError" ||
                            //                 err.msg === "PERMISSION_DENIED"){
                            //                 _this.setState({
                            //                     showStatus: true,
                            //                     videoStatus: 9
                            //                 })
                            //             }else if(err === "DEVICES_NOT_FOUND" || err.msg === "NotFoundError"){
                            //                 Modal.info({
                            //                     title: i18n.showModal.title,
                            //                     content: i18n.globalError.equipmentNotFound,
                            //                     okText: i18n.globalError.btnText,
                            //                     onOk() {
                            //                         //关闭页面
                            //                         history.back();
                            //                         window.close();
                            //                     }
                            //                 })
                            //             }else if(err === "NOT_SUPPORTED"){
                            //                 Modal.info({
                            //                     title: i18n.showModal.title,
                            //                     content: i18n.globalError.browserNotSurport,
                            //                     okText: i18n.globalError.btnText,
                            //                     onOk() {
                            //                         //关闭页面
                            //                         history.back();
                            //                         window.close();
                            //                     }
                            //                 })
                            //             }else{
                            //                 Modal.info({
                            //                     title: i18n.showModal.title,
                            //                     content: i18n.globalError.unknowError,
                            //                     okText: i18n.globalError.btnText,
                            //                     onOk() {
                            //                         //关闭页面
                            //                         history.back();
                            //                         window.close();
                            //                     }
                            //                 })
                            //             }
                            //         }
                            //     })
                            // })
                        });
                    })
                })
            });
        })
    }

    componentWillUnmount() {
        this.trtcRoomInst && this.trtcRoomInst.closeLocalSteam();
        // //SSE接受服务端推送事件关闭
        // if(window.EventSource) {
        //     this.eventSource.close();
        // }
    }

    //初始化录制
    initRecord = () => {
        clearInterval(this.counter);
        this.counter = countNumDown(this.state.count, num => {
            if (typeof num != "undefined") {
                this.setState({
                    count: num
                })
            } else {
                this.startRecord();
            }
        })
    }
    //获取试卷
    getPaper = (index, currentRepeatNum, callback) => {
        const { i18n, papers } = this.state;
        let question = papers.interviewQuesVOs[index];
        console.log("题目序号", index, "，题号等于-1为试录，剩余重录次数: ", currentRepeatNum, "，试题为： ", question);
        if (index < 0) {
            this.setState({
                questionIndex: index,
                isTry: true,
                count: 30,
                question: {
                    answerTime: 0.5,
                    answerSeconds: 30,
                    cnName: i18n.question.demo,
                    enName: i18n.question.demo,
                    questionId: "TRY_VIDEO",
                },
                questionTotal: 1,
                currentRepeatNum: typeof currentRepeatNum === "undefined" ? 1 : currentRepeatNum,
                channelName: this.state.accountId,
                btnText: i18n.replayModal.okText1
            }, () => {
                typeof callback === "function" && callback();
            })
        } else {
            //处理题目思考时间和答题时间
            question.answerTime = question.answerTime || 1;
            question.thinkTime = question.thinkTime || 0.5;
            this.setState({
                questionIndex: index,
                question: question,
                questionTotal: papers.questionNum,
                paperId: papers.paperId,
                repeatNum: papers.repeatAnswerNum,
                currentRepeatNum: typeof currentRepeatNum === "undefined" ? papers.repeatAnswerNum : currentRepeatNum,
                // count: question.thinkTime ? 60 * Number(question.thinkTime) : 30,
                count: Number(question.thinkSeconds || 30),
                channelName: this.state.accountId,
                btnText: index < papers.questionNum - 1 ? i18n.replayModal.okText2 : i18n.replayModal.okText3
            }, () => {
                typeof callback === "function" && callback();
            })
        }
    }
    //开始录制
    startRecord = () => {
        clearInterval(this.counter);
        clearInterval(this.timer);
        this.setState({
            showLoading: true
        })
        let { accountId, channelName, paperId, question, isTry, notAddAccess, isReRecord } = this.state;
        let startUrl = "";
        if (isTry){
        //   startUrl = "/v1/record/tryRecord";
          startUrl = "/v2/record/tryRecord";
        } else {
          // startUrl = "/v1/record/startService";
          // startUrl = "/v2/record/startRecord";
          startUrl = "/v3/record/startRecord";
        }
        ajax({
            url: startUrl,
            method: "get",
            data: {
                channelName: channelName,
                userId: accountId,
                paperId: paperId,
                questionId: question.questionId,
                videoSource: 2,
                resumePoint: 1,
                retry: isReRecord,  // 是否重录
            }
        }).then(res => {
            this.setState({
                isStart: true,
                showProgress: true,
                showLoading: false,
                isReRecord: false,
                fileNamePrefix: (res || {}).data || "",
            })
            if(!isTry && notAddAccess){
                //增加访问次数
                ajax({
                    url: "/account/addAccessNum"
                }).then(res => {
                    this.setState({
                        notAddAccess: false
                    })
                })
            }
            // 加入房间并发布流
            ajax({
                url: "/sys/getUserSig",
                data: {
                    // userId: `${accountId}_${question.questionId || "TRY_VIDEO"}`
                    userId: accountId
                }
            }).then(res => {
                this.trtcRoomInst.createAndjoinAndPublish({
                    userDefineRecordId: question.questionId || "TRY_VIDEO",
                    // userID: `${accountId}_${question.questionId || "TRY_VIDEO"}`,
                    userID: accountId,
                    ...res.data
                }, () => {
                    // let countTime = Number(question.answerTime) * 60;
                    let countTime = Number(question.answerSeconds);
                    countTime = isNaN(countTime)?30:countTime;
                    this.timer = countTimeDown(countTime, time => {
                        if (typeof time != "undefined") {
                            this.setState({
                                time: time,
                                recordSecond: this.state.recordSecond + 1
                            })
                        } else {
                            this.stopRecord();
                        }
                    });
                });
            })
        }).catch(err => {
            this.setState({
                showLoading: false
            })
        })
    }
    //停止录制
    stopRecord = () => {
        const _this = this;
        const { i18n } = this.state;
        if (this.state.recordSecond < 10) {
            message.destroy()
            message.success(i18n.record.timeLimitText, 3);
        } else {
            clearInterval(this.timer);
            this.setState({
                showLoading: true
            })
            ajax({
                url: '/v1/record/stopRecord',
                method: "post"
            }).then(data => {
                this.setState({
                    isStart: false,
                    showProgress: false,
                    time: "00:00:00",
                    count: 30,
                    showModal: true,
                    recordSecond: 0,
                    showLoading: false
                })
                // 退出房间
                this.trtcRoomInst.leave();
                // 弹框20s不操作就自动提交到下一题或者整体提交
                this.limitOperateTimer = countNumDown(20, num => {
                    this.setState({
                        limitTime: num
                    })
                    if (typeof num == "undefined") {
                        this.toNext();
                        message.info(this.state.btnText);
                    }
                })
            }).catch(e => {
                this.setState({
                    isStart: false,
                    showProgress: false,
                    time: "00:00:00",
                    count: 30,
                    recordSecond: 0,
                    showLoading: false
                })
                Modal.info({
                    title: i18n.showModal.title,
                    content: i18n.record.recordFailText,
                    okText: i18n.stopRecordModal.rerecordText,
                    onOk() {
                        _this.getPaper(_this.state.questionIndex, _this.state.currentRepeatNum, _this.initRecord);
                    }
                })
            })
        }
    }
    hideConfirmModal = () => {
        const { i18n } = this.state;
        const { currentReplayNum } = this.state;
        this.setState({
            showModal: currentReplayNum == 2,
            showReplayModal: currentReplayNum < 2,
            showConfirmModal: false
        })
        // 弹框20s不操作就自动提交到下一题或者整体提交
        this.limitOperateTimer = countNumDown(20, num => {
            this.setState({
                limitTime: num
            })
            if (typeof num == "undefined") {
                this.toNext();
                message.info(this.state.btnText);
            }
        })
    }
    //隐藏loading框
    hideLoading = () => {
        this.setState({
            showLoading: false
        })
    }
    //回放
    toReplay = () => {
        //清除自动提交定时器
        clearInterval(this.limitOperateTimer);
        this.setState({
            showModal: false,
            mode: "player",
            showProgress: true,
            currentReplayNum: 1,
            limitTime: undefined,
            showLoading: true
        });
        // 腾讯录制获取视频回放地址
        const { question, i18n, fileNamePrefix } = this.state;
        ajax({
            url: "/v1/record/watchRecord",
            data: {
                questionId: question.questionId || "TRY_VIDEO",
                fileNamePrefix
            }
        }).then(res => {
            this.setState({
                videoUrl: res.data.url,
                duration: res.data.duration
            })
        }).catch(err => {
            message.error(i18n.replayModal.replayFailText);
            this.hideLoading();
        })
        return false;
        // 声网录制获取视频回放地址
        if (this.state.isTry) {
            ajax({
                url: "/v1/record/getVideoDuration",
                data: {
                    questionId: question.questionId
                }
            }).then(res => {
                this.setState({
                    videoUrl: location.origin + '/oivi/record/watchRecord?t='+ new Date().getTime(),
                    duration: res.data
                })
            })
        }else{
            const { i18n, accountId, paperId } = this.state;
            ajax({
                url: '/api/file/viewVideo',
                data: {
                    accountId,
                    paperId,
                    questionId: question.questionId
                }
            }).then(res => {
                const rootUrl = location.origin;//location.protocol + "//" + location.hostname;
                this.setState({
                    videoUrl: rootUrl + "/oivi/api/file/review/" + res.data.videoFileUrl,
                    duration: res.data.duration,
                    btnText: this.state.questionIndex < this.state.papers.questionNum - 1 ? i18n.replayModal.okText2 : i18n.replayModal.okText3
                })
            })
        }
    }

    //重新回放
    toNextReplay = () => {
        if (this.state.currentReplayNum > 0) {
            //清除自动提交定时器
            clearInterval(this.limitOperateTimer);
            //重新加载视频
            this.videoPlayer.current.load();
            this.setState({
                showReplayModal: false,
                currentReplayNum: 0,
                showProgress: true,
                limitTime: undefined
            })
        }else{
            const { i18n } = this.state;
            Modal.info({
                title: i18n.showModal.title,
                content: i18n.record.replayLimitText,
                okText: i18n.device.btnText,
            })
        }
    }
    //重录
    toReRecord = () => {
        if (this.state.currentRepeatNum > 0) {
            //清除自动提交定时器
            clearInterval(this.limitOperateTimer);
            if(this.state.showConfirmModal){
                // 重录时，清除之前的定时器
                this.setState({
                    currentRepeatNum: this.state.currentRepeatNum - 1,
                    showModal: false,
                    showReplayModal: false,
                    showConfirmModal: false,
                    mode: "pusher",
                    currentReplayNum: 2,
                    recordSecond: 0,
                    limitTime: undefined,
                    isReRecord: true,
                }, () => {
                    this.getPaper(this.state.questionIndex, this.state.currentRepeatNum, this.initRecord);
                })
            }else{
                this.setState({
                    showModal: false,
                    showReplayModal: false,
                    showConfirmModal: true,
                    limitTime: undefined,
                    isReRecord: true,
                })
            }
        }else{
            const { i18n } = this.state;
            Modal.info({
                title: i18n.showModal.title,
                content: i18n.record.rerecordLimitText,
                okText: i18n.device.btnText,
            })
        }
    }
    //下一题
    toNext = () => {
        //清除自动提交定时器
        clearInterval(this.limitOperateTimer);
        const _this = this;
        const { i18n } = this.state;
        if (this.state.isTry) {
            this.setState({
                showModal: false,
                showReplayModal: false,
                showTryFinish: true,
                mode: "pusher",
                currentReplayNum: 2,
                recordSecond: 0,
                limitTime: undefined
            })
            // 弹框20s不操作就自动提交到下一题或者整体提交
            this.limitOperateTimer = countNumDown(20, num => {
                this.setState({
                    limitTime: num
                })
                if (typeof num == "undefined") {
                    message.info(i18n.tryFinish.btnText, this.toRecord);
                }
            })
        } else {
            if (this.state.questionIndex < this.state.questionTotal - 1) {
                this.setState({
                    showModal: false,
                    showReplayModal: false,
                    mode: "pusher",
                    currentReplayNum: 2,
                    recordSecond: 0,
                    limitTime: undefined
                })
                this.getPaper(this.state.questionIndex + 1, undefined, this.initRecord);
            } else {
                this.setState({
                    limitTime: undefined
                })
                ajax({
                    url: '/account/finishQuestion'
                }).then(res => {
                    this.trtcRoomInst.closeLocalSteam();
                    this.props.history.replace({
                        pathname: "suggest",
                        search: "?accountId="+ this.state.accountId + "&lang=" + i18n.lang
                    })
                    //离开频道
                    // agoraClient.leave(() => {
                    //     console.log("Leave channel successfully");
                    //     try {
                    //         //关闭视频
                    //         this.state.recordStream.close();
                    //     }catch(e){}
                    //     this.props.history.replace({
                    //         pathname: "suggest",
                    //         search: "?accountId="+ this.state.accountId + "&lang=" + i18n.lang
                    //     })
                    // }, err => {
                    //     console.log("Leave channel failed");
                    // });
                })
            }
        }
    }
    //结束回放
    stopReplay = () => {
        this.videoPlayer.current.pause();
        this.setState({
            showReplayModal: true,
            recordSecond: 0,
            limitTime: undefined
        });
        // 弹框20s不操作就自动提交到下一题或者整体提交
        this.limitOperateTimer = countNumDown(20, num => {
            this.setState({
                limitTime: num
            })
            if (typeof num == "undefined") {
                this.toNext();
                message.info(this.state.btnText);
            }
        })
    }
    //正式录制
    toRecord = () => {
        const { i18n } = this.state;
        //清除自动提交定时器
        clearInterval(this.limitOperateTimer);
        document.title = i18n.pageTitle.record;
        this.setState({
            isTry: false,
            showTryFinish: false,
            limitTime: undefined
        })
        this.getPaper(0, undefined, this.initRecord); 
    }
    //调整姿势完毕
    adjustPosture = () => {
        this.setState({
            showPosture: false
        }, () => {
            this.initRecord();
        })
    }
    //关闭状态弹窗
    hideStatusModal = () => {
        //关闭页面
        history.back();
        window.close();
    }
    
    render(){
        const {
            isStart,
            count,
            question,
            questionIndex,
            questionTotal,
            currentRepeatNum,
            repeatNum,
            btnText,
            mode,
            videoUrl,
            time,
            showProgress,
            recordSecond,
            currentReplayNum,
            showLoading,
            duration,
            isTry,
            showPosture,
            showStatus,
            videoStatus,
            i18n,
            limitTime,
            isRecordReady
        } = this.state;

        const antIcon = <Icon type="loading" style={{ fontSize: 36 }} spin />;
        
        // 国际化
        if(!i18n) return null;

        return(
            <Spin indicator={antIcon} spinning={showLoading} wrapperClassName="spin-class">
                <div className="video-app-wrap video-background-wrap">
                    <VideoHeader i18n={i18n} />
                    <div className="video-check-nav">
                        <img src={videoHome} />
                        <strong>{i18n.pageTitle.index}</strong>
                        <span>{' > '}</span>
                        <strong>{isTry ? i18n.pageTitle.tryRecord : i18n.pageTitle.record}</strong>
                    </div>
                    <div className="video-main-wrap">
                        <VideoPusher
                            visible={mode==="pusher"}
                            showProgress={showProgress}
                            isStart={isStart}
                            showPosture={showPosture}
                            question={question}
                            count={count}
                            recordSecond={recordSecond}
                            questionIndex={questionIndex}
                            questionTotal={questionTotal}
                            adjustPosture={this.adjustPosture}
                            stopRecord={this.stopRecord}
                            startRecord={this.startRecord}
                            time={time}
                            i18n={i18n}
                            isRecordReady={isRecordReady}
                        />
                        <VideoPlayer
                            visible={mode==="player"}
                            videoUrl={videoUrl}
                            question={question}
                            i18n={i18n}
                            questionIndex={questionIndex}
                            questionTotal={questionTotal}
                            stopReplay={this.stopReplay}
                            handleCanPlay={this.hideLoading}
                            ref={this.videoPlayer} />
                    </div>
                    <VideoModel title={i18n.stopRecordModal.title}
                        size="small"
                        visible={this.state.showModal}>
                        <div className="video-officialCon">
                            <div className="video-officialConPic" onClick={this.toReplay}>
                                <img className="video-replay-img" src={videoPlayAgain}/>
                                <span>{i18n.stopRecordModal.playbackText}(2/2)</span>
                            </div>
                            {
                                repeatNum > 0 && <div className="video-officialConPic" onClick={this.toReRecord}>
                                    <img className="video-record-img" src={videoReplay}/>
                                    <span>{i18n.stopRecordModal.rerecordText}({ currentRepeatNum }/{ repeatNum })</span>
                                </div>
                            }
                        </div>
                        <button className="video-officialBtn" onClick={this.toNext}>
                            {btnText}
                            { limitTime ? <span>{i18n.replayModal.autoText}({limitTime}s)</span> : null }
                        </button>
                    </VideoModel>
                    <VideoModel title={i18n.stopRecordModal.title}
                        size="small"
                        visible={this.state.showReplayModal}>
                        <div className="video-officialCon">
                            <div className="video-officialConPic" onClick={this.toNextReplay}>
                                <img className="video-replay-img" src={videoPlayAgain}/>
                                <span>{i18n.stopRecordModal.playbackText}({currentReplayNum}/2)</span>
                            </div>
                            {
                                repeatNum > 0 && <div className="video-officialConPic" onClick={this.toReRecord}>
                                    <img className="video-record-img" src={videoReplay}/>
                                    <span>{i18n.stopRecordModal.rerecordText}({ currentRepeatNum }/{ repeatNum })</span>
                                </div>
                            }
                        </div>
                        <button className="video-officialBtn" onClick={this.toNext}>
                            {btnText}
                            { limitTime ? <span>{i18n.replayModal.autoText}({limitTime}s)</span> : null }
                        </button>
                    </VideoModel>
                    <VideoModel visible={this.state.showConfirmModal}
                        title={i18n.stopRecordModal.title}>
                        <div className="model-record-wrap">
                            <img className="model-record-img" src={startRecord} />
                            <p className="model-record-content">{i18n.stopRecordModal.confirmTitle}</p>
                            <p className="model-record-content">{i18n.stopRecordModal.confirmSubtitle}</p>
                            <p className="model-record-content" style={{color: "red"}}>
                                {i18n.stopRecordModal.confirmRed}
                                {currentRepeatNum}
                            </p>
                            <div className="model-record-btns">
                                <div className="model-record-btn model-btn-blank" onClick={this.hideConfirmModal}>
                                    {i18n.stopRecordModal.confirmBtnCancel}
                                </div>
                                <div className="model-record-btn model-btn-fill" onClick={this.toReRecord}>
                                    {i18n.stopRecordModal.rerecordText}
                                </div>
                            </div>
                        </div>
                    </VideoModel>
                    <VideoModel title={i18n.tryFinish.title}
                        visible={this.state.showTryFinish}>
                        <div className="tryRecord-finish">
                            <img className="tryRecord-finish-img" src={tryFinish} />
                            <div className="tryRecord-finish-content">{i18n.tryFinish.subtitle1}</div>
                            <div className="tryRecord-finish-content">{i18n.tryFinish.subtitle2}</div>
                            <button className="tryRecord-finish-btn" onClick={this.toRecord}>
                                {i18n.tryFinish.btnText}
                                { limitTime ? <span>{i18n.replayModal.autoText}({limitTime}s)</span> : null }
                            </button>
                        </div>
                    </VideoModel>
                    <VideoModel title={i18n.showModal.titlePC} visible={showStatus}>
                        <VideoStatus status={videoStatus} hideModal={this.hideStatusModal} i18n={i18n} />
                    </VideoModel>
                    <VideoFooter i18n={i18n} />
                {/*<div id="agora_remote" style={{width: "640px", height: "480px"}}></div>*/}
                </div>
            </Spin>
        )
    }
}

export default App;